// Chips da linha do tempo (.tk-tl-chips) e da fila (.tk-filtros, D18): a roda vertical do mouse rola na horizontal quando o
// ponteiro está sobre eles; D22: arrastar com o mouse também desliza a faixa.
// FAIL do dono (d03): com mouse de roda só vertical não havia como rolar os chips.
// O listener de wheel com passive:false fica SÓ em cada .tk-tl-chips/.tk-filtros (ligado no 1º mouseover, porque a linha do
// tempo chega por ajax); o resto da página continua com wheel passivo. Só intercepta quando há overflow horizontal,
// o gesto é vertical (deltaX ≈ 0) e ainda há para onde rolar naquele sentido — no fim, a coluna rola normalmente.

// D22 (d22-v01 + parecer-d22-design): arrastar com o MOUSE para deslizar as duas faixas. Pointer events só mouse / botão 0 / primário;
// abaixo de LIMIAR_PX nada rola e o clique segue intacto (LICOES 43); acima: data-arrastando, setPointerCapture SÓ depois do limiar,
// scrollLeft = s0 − dx, e o click desta tarefa é engolido na captura de window. Quem garante que nada mais age é o ALVO desse click (a
// própria faixa, por causa da captura de ponteiro), e não a ordem: o SaidaDetalhe também captura click em window e roda antes, mas a faixa
// não está na lista dele (R3 do parecer). Toque/caneta: rolagem nativa. Sem inércia (D22-2), sem scroll-snap (D22-3).

const Foco = require('./LinhaTempoFoco');   // d24-v05 §2.2: a mesma regra dos desfechos assíncronos do NotaInterna

const LINHA_PX = 16;   // deltaMode 1 (linhas) → px
const LIMIAR_PX = 6;   // |Δx| a partir do qual o gesto é arrasto, e não clique
const FAIXAS = '.tk-tl-chips, .tk-filtros, .tk-faixa-dados';   // D35 v15 J-1: a meta da barra (3 datas) também é slider

const ChipsRolagem = function () {

    const ligados = new WeakSet();

    const rodar = function (e) {
        const el = e.currentTarget;
        const sobra = el.scrollWidth - el.clientWidth;
        if (sobra <= 0 || Math.abs(e.deltaX) > 1 || e.deltaY === 0) return;
        const passo = e.deltaY * (e.deltaMode === 1 ? LINHA_PX : 1);
        const noInicio = el.scrollLeft <= 0;
        const noFim = el.scrollLeft >= sobra - 1;
        if ((passo < 0 && noInicio) || (passo > 0 && noFim)) return;
        e.preventDefault();
        el.scrollLeft += passo;
    };

    // D22 §2.4: `grab` só quando há para onde arrastar (calculado na ligação e a cada entrada do ponteiro).
    // D35 v17: o mesmo limiar do estadoMeta (1 px de sobra = `nenhum`), senão a faixa que cabe mostra `grab` sem esmaecido.
    const marcarArrastavel = (el) => { el.toggleAttribute('data-arrastavel', el.scrollWidth - el.clientWidth > 1); };
    const aoEntrar = (e) => marcarArrastavel(e.currentTarget);

    const ligar = function (e) {
        const el = e.target instanceof Element ? e.target.closest(FAIXAS) : null;
        if (!el || ligados.has(el)) return;
        ligados.add(el);
        el.addEventListener('wheel', rodar, { passive: false });
        el.addEventListener('pointerenter', aoEntrar);
        marcarArrastavel(el);
    };

    // ---------- D22: arrasto com o mouse ----------
    let gesto = null;     // { el, id, x0, s0, ativo }
    let engolir = false;  // o click desta tarefa vem de um arrasto: descartar

    const soltarOuvintes = () => {
        window.removeEventListener('pointermove', mover);
        window.removeEventListener('pointerup', terminar);
        window.removeEventListener('pointercancel', terminar);
        if (gesto) gesto.el.removeEventListener('lostpointercapture', terminar);
    };

    const comecar = function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0 || !e.isPrimary || gesto) return;   // toque/caneta: rolagem nativa
        const el = e.target instanceof Element ? e.target.closest(FAIXAS) : null;
        if (!el || el.scrollWidth - el.clientWidth <= 1) return;                           // sem rolagem (≤ 1 px, o limiar do data-rola): só clique
        const r = el.getBoundingClientRect();
        if (e.clientY - r.top >= el.clientTop + el.clientHeight) return;                   // barra clássica da linha do tempo
        gesto = { el, id: e.pointerId, x0: e.clientX, s0: el.scrollLeft, ativo: false };
        window.addEventListener('pointermove', mover, { passive: true });
        window.addEventListener('pointerup', terminar);
        window.addEventListener('pointercancel', terminar);
        el.addEventListener('lostpointercapture', terminar);
        // SEM preventDefault, SEM foco, SEM captura: um clique sem movimento é idêntico ao de hoje
    };

    const mover = function (e) {
        if (!gesto || e.pointerId !== gesto.id) return;
        const dx = e.clientX - gesto.x0;
        if (!gesto.ativo) {
            if (Math.abs(dx) < LIMIAR_PX) return;                                           // nada rola (LICOES 43)
            gesto.ativo = true;
            gesto.el.setAttribute('data-arrastando', '');
            try { gesto.el.setPointerCapture(gesto.id); } catch (err) { /* ponteiro já solto */ }
            const sel = window.getSelection ? window.getSelection() : null;
            if (sel) sel.removeAllRanges();
        }
        gesto.el.scrollLeft = gesto.s0 - dx;                                                 // o navegador limita a [0, sobra]
    };

    const terminar = function (e) {
        if (!gesto || (e.pointerId !== undefined && e.pointerId !== gesto.id)) return;
        const g = gesto;
        soltarOuvintes();
        gesto = null;
        if (g.ativo) {
            g.el.removeAttribute('data-arrastando');
            try { g.el.releasePointerCapture(g.id); } catch (err) { /* já solta */ }
            if (e.type === 'pointerup') { engolir = true; setTimeout(() => { engolir = false; }, 0); }   // só o click desta tarefa
        }
    };

    const engolirClique = function (e) {
        if (!engolir) return;
        engolir = false;
        e.preventDefault();
        e.stopImmediatePropagation();
    };

    // D05: depois que a timeline é re-renderizada por clique num chip, o foco volta ao chip ativo e a barra rola só
    // na horizontal até ele. Observer de uso único no #ticket-detail-timeline daquele clique (desliga na 1ª troca ou
    // em 60 s; um clique novo substitui o anterior) — nada fica preso a cada ticket aberto, e a carga inicial não entra.
    let vigia = null;
    let teto = null;
    const soltar = () => { if (vigia) { vigia.disconnect(); vigia = null; } clearTimeout(teto); teto = null; };

    const focarAtivo = (alvo) => {
        if (!alvo.isConnected || !Foco.podeFocar(alvo)) return;   // d24-v05 §2.2 (S10): modal aberto ou foco fora da coluna → não move
        const bar = alvo.querySelector('.tk-tl-chips');
        const chip = bar ? bar.querySelector('.tk-chip[aria-pressed="true"]') : null;
        if (!chip) return;   // resposta de erro sem chips: nada a focar
        chip.focus({ preventScroll: true });
        const b = bar.getBoundingClientRect();
        const c = chip.getBoundingClientRect();
        const visivel = c.left >= b.left && c.right <= b.right - 32;   // 32 = esmaecido da direita
        if (!visivel) bar.scrollLeft += (c.left - b.left) - (b.width - c.width) / 2;   // só eixo X
    };

    // d24-v05 §2.1 (O3/S14): o aviso persistente (.tk-tl-lista-erro) e a linha de 6 s (p.tk-tl-nota-aviso) são filhos diretos da coluna.
    // Um lote em que TODO elemento inserido/removido é um deles não é a troca do chip e não arma o foco.
    const RUIDO = '.tk-tl-lista-erro, p.tk-tl-nota-aviso';
    const soRuido = (m) => [...m.addedNodes, ...m.removedNodes].every(n => n.nodeType !== 1 || n.matches(RUIDO));

    const aoClicarChip = (e) => {
        const chip = e.target instanceof Element ? e.target.closest('.tk-tl-chips .tk-chip') : null;
        const alvo = chip ? chip.closest('#ticket-detail-timeline') : null;
        if (!alvo) return;
        soltar();
        vigia = new MutationObserver((lotes) => {
            if (lotes.every(soRuido)) return;   // aviso/linha de 6 s entrando ou saindo: continua vigiando (até a troca real ou 60 s)
            soltar();
            focarAtivo(alvo);
        });
        vigia.observe(alvo, { childList: true });
        teto = setTimeout(soltar, 60000);
    };

    // D35 v15 J-2 (DF-11): a meta da barra é slider de uma linha (lab talk.js:1758-1799). data-rola liga o esmaecido do lado em que há
    // mais (CSS); tabindex=0 só quando rola, para o teclado (←/→ nativas do contêiner rolável) alcançar o escondido. A faixa chega por ajax
    // (replaceContent do detalhe): um MutationObserver no .open-ticket-detail, com 1 varredura por quadro (o chat muda o DOM o tempo todo).
    // O observer não olha atributos: o data-rola/tabindex que este bloco escreve não o redisparam (parecer-d35-v15 ponto 1).
    const METAS = '.tk-faixa-dados';
    // D35 v17 G-M8a (lab talk.css:1373-1384): as fileiras de chips da fila ganham o mesmo data-rola (esmaecido pelo lado que tem mais),
    // SEM o tabindex: os chips já são focáveis. As fileiras não são trocadas por AJAX: varredura 1× no init + ResizeObserver.
    const FILEIRAS = '#tk-fila .tk-filtros';
    const estadoMeta = (el) => {
        const max = el.scrollWidth - el.clientWidth;
        const st = max <= 1 ? 'nenhum' : (el.scrollLeft <= 1 ? 'inicio' : (el.scrollLeft >= max - 1 ? 'fim' : 'meio'));
        if (el.dataset.rola !== st) el.dataset.rola = st;
        if (el.hasAttribute('data-arrastavel') !== (max > 1)) el.toggleAttribute('data-arrastavel', max > 1);   // D22 `grab` acompanha a largura (antes, só no pointerenter)
        if (el.matches(FILEIRAS)) return;   // comTab: false
        if (st === 'nenhum') el.removeAttribute('tabindex');
        else if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
    };
    const roMeta = window.ResizeObserver ? new ResizeObserver((ents) => ents.forEach((en) => {
        const el = en.target.closest(METAS + ', ' + FILEIRAS);
        if (!el || !el.isConnected) { roMeta.unobserve(en.target); return; }
        estadoMeta(el);
    })) : null;
    const metasLigadas = new WeakSet();
    const ligarMeta = (el) => {
        if (roMeta) { roMeta.observe(el); Array.from(el.children).forEach((c) => roMeta.observe(c)); }   // filhos: a troca de fonte muda o scrollWidth sem mudar a dl
        if (!metasLigadas.has(el)) { metasLigadas.add(el); el.addEventListener('scroll', () => estadoMeta(el), { passive: true }); }
        estadoMeta(el);
    };
    let quadroMeta = 0;
    const vigiarMeta = (raiz) => {
        if (!raiz) return;
        const varrer = () => { quadroMeta = 0; raiz.querySelectorAll(METAS).forEach(ligarMeta); };
        varrer();
        new MutationObserver(() => { if (!quadroMeta) quadroMeta = requestAnimationFrame(varrer); }).observe(raiz, { childList: true, subtree: true });
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(varrer);
    };

    return {
        init: function () {
            if (!document.querySelector('.open-ticket-detail')) return;   // só na tela de tickets nova
            vigiarMeta(document.querySelector('.open-ticket-detail'));   // D35 v15 J-3
            const fileiras = () => document.querySelectorAll(FILEIRAS).forEach(ligarMeta);   // D35 v17 G-M8a
            fileiras();
            if (document.fonts && document.fonts.ready) document.fonts.ready.then(fileiras);
            document.addEventListener('mouseover', ligar, { passive: true });
            document.addEventListener('click', aoClicarChip);   // sem preventDefault: o .bt-ajax do chip segue
            document.addEventListener('pointerdown', comecar, { passive: true });   // D22
            window.addEventListener('click', engolirClique, true);                  // D22: click pós-arrasto descartado
        },
    };
}();

module.exports = ChipsRolagem;
